const initialState = {
  projects: [],
  filterYearProjects: null,
};

const GET_PROJECTS = 'GET_PROJECTS';
const SET_YEAR_FILTER_PROJECTS = 'SET_YEAR_FILTER_PROJECTS';

export const projectsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PROJECTS:
      return { ...state, projects: action.payload };
    case SET_YEAR_FILTER_PROJECTS:
      return { ...state, filterYearProjects: action.payload };
    default:
      return state;
  }
};

export const getProjectsAction = (payload) => ({ type: GET_PROJECTS, payload });
export const setYearFilterProjects = (year) => ({
  type: SET_YEAR_FILTER_PROJECTS,
  payload: year,
});
